import { render } from "./SupportRequestDetail.vue?vue&type=template&id=f25c8452&scoped=true&ts=true"
import script from "./SupportRequestDetail.vue?vue&type=script&lang=ts"
export * from "./SupportRequestDetail.vue?vue&type=script&lang=ts"

import "./SupportRequestDetail.vue?vue&type=style&index=0&id=f25c8452&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25c8452"]])

export default __exports__